var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-btn-dropdown",
    {
      attrs: {
        split: "",
        color: "primary",
        label: _vm.$t(
          "button.logSearchSorting." + _vm.logSearchParams.orderBy[0]
        ),
        icon: _vm.sortingIcon,
        disable: _vm.disableSorting,
        "no-caps": ""
      },
      on: {
        click: function($event) {
          return _vm.$emit("updatedSortingDirection", _vm.disableSorting)
        }
      }
    },
    [
      _c(
        "q-list",
        _vm._l(_vm.options, function(label, option) {
          return _c(
            "q-item",
            {
              directives: [{ name: "close-popup", rawName: "v-close-popup" }],
              key: option,
              attrs: { clickable: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("updatedSorting", option, _vm.disableSorting)
                }
              }
            },
            [
              _c(
                "q-item-section",
                [_c("q-item-label", [_vm._v(_vm._s(_vm.$t(label)))])],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }